import { render } from "./BillsList.vue?vue&type=template&id=36f63263&scoped=true"
import script from "./BillsList.vue?vue&type=script&lang=ts"
export * from "./BillsList.vue?vue&type=script&lang=ts"

import "./BillsList.vue?vue&type=style&index=0&id=36f63263&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36f63263"

export default script